import React from 'react';
import { Box, Popover, Typography } from '@mui/material';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

const MenuItem = ({ icon: Icon, label, color, hoverColor, hoverBg, onClick }) => (
    <Box
        onClick={onClick}
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            '&:hover': {
                backgroundColor: hoverBg || '#f5f3ff',
                '& .menu-icon': { color: hoverColor || '#6366f1' },
                '& .menu-text': { color: hoverColor || '#6366f1' }
            }
        }}
    >
        <Box
            sx={{
                width: 36,
                height: 36,
                borderRadius: '8px',
                backgroundColor: `${color}12`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Icon className="menu-icon" sx={{ fontSize: 20, color: color, transition: 'color 0.15s ease' }} />
        </Box>
        <Typography
            className="menu-text"
            sx={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#374151',
                transition: 'color 0.15s ease'
            }}
        >
            {label}
        </Typography>
    </Box>
);

const GameTagMenu = ({ anchor, onClose, onView, onHudl, onRender, onEdits, t }) => {
    const menuPopoverOpen = Boolean(anchor);
    const menuPopoverId = menuPopoverOpen ? 'simple-popover' : undefined;

    return (
        <Popover
            id={menuPopoverId}
            open={menuPopoverOpen}
            anchorEl={anchor}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
                '& .MuiPopover-paper': {
                    width: '220px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                    border: '1px solid #e5e7eb',
                    overflow: 'hidden',
                    marginTop: '8px'
                }
            }}
        >
            <Box sx={{ padding: '8px 0' }}>
                <MenuItem
                    icon={PlayCircleOutlineIcon}
                    label={t('View Clips')}
                    color="#6366f1"
                    hoverColor="#6366f1"
                    hoverBg="#f5f3ff"
                    onClick={onView}
                />
                <MenuItem
                    icon={FileDownloadOutlinedIcon}
                    label={t('Export to Sportcode')}
                    color="#0ea5e9"
                    hoverColor="#0ea5e9"
                    hoverBg="#f0f9ff"
                    onClick={onHudl}
                />
                <MenuItem
                    icon={EditNoteOutlinedIcon}
                    label={t('Export to My Edits')}
                    color="#f59e0b"
                    hoverColor="#f59e0b"
                    hoverBg="#fffbeb"
                    onClick={onEdits}
                />
            </Box>
        </Popover>
    );
};

export default GameTagMenu;
